import { checkHasPermission, getStationType } from '@spx-portal/shared-utils';
import * as React from 'react';

import { VueCtxStore } from '@/common/appCtx';

export const usePermissions = () => {
  const permissions = React.useMemo(() => {
    return {
      workstationSet: {
        DC: 'DC_WORKSTATION_ACTIVITY_SET',
        AM_HUB: 'WORKSTATION_ACTIVITY_SET',
        FM_HUB: 'WORKSTATION_ACTIVITY_SET',
        HUB: 'WORKSTATION_ACTIVITY_SET',
      },
      workstationList: {
        DC: 'DC_WORKSTATION_ACTIVITY_LIST',
        AM_HUB: 'WORKSTATION_ACTIVITY_LIST',
        FM_HUB: 'WORKSTATION_ACTIVITY_LIST',
        HUB: 'WORKSTATION_ACTIVITY_LIST'
      },
      workstationBatchAction: {
        DC: 'DC_WORKSTATION_BATCH_ACTION',
        AM_HUB: 'WORKSTATION_BATCH_ACTION',
        FM_HUB: 'WORKSTATION_BATCH_ACTION',
        HUB: 'WORKSTATION_BATCH_ACTION',
      },
      workstationBatchLog: {
        DC: 'DC_WORKSTATION_BATCH_LOG',
        AM_HUB: 'WORKSTATION_BATCH_LOG',
        FM_HUB: 'WORKSTATION_BATCH_LOG',
        HUB: 'WORKSTATION_BATCH_LOG',
      }
    };
  }, []);
  const hasPermission = React.useCallback((permission: keyof typeof permissions) => {
    const targetPermission = permissions[permission];
    const stationType = getStationType() as keyof typeof targetPermission;
    return targetPermission[stationType]
      ? !!checkHasPermission(VueCtxStore, targetPermission[stationType])
      : false;
  }, [permissions]);
  return hasPermission;
};
